import { render, staticRenderFns } from "./CustomSearchFollowup.vue?vue&type=template&id=e554143a"
import script from "./CustomSearchFollowup.vue?vue&type=script&lang=js"
export * from "./CustomSearchFollowup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports